import { AccessToken, AuthSession, TwoFactorToken } from '../../../../types';

/**
 * A fully verified session: both the first-factor token and the second-factor
 * token are present.
 */
export const authenticatedSession = (
  jwt: AccessToken,
  expiresAt: string,
  twoFactorToken: TwoFactorToken,
): AuthSession => ({
  status: 'authenticated',
  jwt,
  expiresAt,
  twoFactorToken,
});
